import React from 'react';
import ReactDOM from 'react-dom/client';
import VideoSlider from './Components/VideoSlider';

const videoSliders = document.getElementsByClassName('video-slider');

for (let i = 0; i < videoSliders.length; i++) {
  const videoSlider = videoSliders[i];
  const srcs = Array.from(videoSlider.getElementsByTagName('video')).map(video => video.src);

  ReactDOM.createRoot(videoSlider).render(
    <VideoSlider srcs={srcs} />
  );
}
